var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"mc-select-group__wrap"},[_c('li',{staticClass:"mc-select-group__title"},[_vm._v(_vm._s(_vm.label))]),_vm._v(" "),_c('li',[_c('ul',{staticClass:"mc-select-group"},[_vm._t("default")],2)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


// WEBPACK FOOTER //
// ./src/components/base-select-group.vue